'use client';

import { useSticky, useResizeObserver } from '@weareconceptstudio/core';
import { CartTemplate as DefaultCartTemplate } from '@weareconceptstudio/account';
import { EmptyCartIcon } from './util';
import Icon from '@/components/common/Icon';

const CartTemplate = () => {
	const resize = useResizeObserver(document.querySelector('body'));

	useSticky({
		enabled: true,
		breakpoint: 1024,
		loading: false,
		dependencies: [resize],
		headerName: '.header',
		markers: false,
	});

	return (
		<DefaultCartTemplate
			emptyCartIcon={<EmptyCartIcon />}
			backToShopIcon={
				<Icon
					name='arrow'
					className='icon-back-to-shop'
				/>
			}
		/>
	);
};

export default CartTemplate;
